import { Component, OnInit } from '@angular/core';
import { TagNcaseManagementService } from '../../services/TagNcaseManagement.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { TagInfoEnum } from './TagInfoEnum';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-tag-sharing',
  templateUrl: './ha-tag-sharing.component.html',
  styleUrls: ['./ha-tag-sharing.component.css']
})

export class HaTagSharingComponent implements OnInit {
  columnTagStatus: boolean;
  imageTagStatus: boolean;
  descriptionTagStatus: boolean;
  showOverlayTag: boolean;
  //where is_used =true checked and show all tags
  reportTagsList: any[];
  //where is_used is not checked and show all tags
  allReportTagsList: any[];
  descriptionTagsList: any[];
  stateList: any[] = [];
  imageTagsList: any[];
  public activeElement = '1';
  countryTagStatus: boolean = false;
  showAddLoader: boolean = false;
  searchTermState: string = '';
  mainViewError = new ErrorModel();
  constructor(private _service: TagNcaseManagementService) { }

  ngOnInit() {
    this.columnTagStatus = true;
    this.imageTagStatus = false;
    this.descriptionTagStatus = false;
    this.getTagsData();

  }


  //function not in use temporarily previously it was getting used for displaying states api is also commited
  getStates() {
    this._service.getStates().subscribe(
    (data: any[]) => {
      this.stateList = data;
      this.showOverlayTag = false;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not get states!', AlertType.Error);
    });
  }

  //code for deleting report tag
  //<!--commit-->
  deleteReportTag(tagId, type) {
    this.showOverlayTag = true;
    this._service.deleteTag(tagId, type).subscribe(
    (data) => {
      let changedIndex = this.reportTagsList.findIndex(i => i.id == tagId);
      this.reportTagsList[changedIndex]['isUsed'] = false;
      AlertMessages.Show('Disabled', 'Tag ' + this.allReportTagsList[this.allReportTagsList.findIndex(i => i.id == tagId)].tagName + ' is Disabled', AlertType.Error);
    },
    (error) => {
      AlertMessages.Show('Failed','Could not Delete!', AlertType.Error);
    }).add(() => {
      this.showOverlayTag = false;
    });
  }


  //code for inserting report tag
  insertReportTag(tagId, tagValue) {
    if (tagValue == '' || tagValue == undefined || tagValue == null) {
    //  this.deleteReportTag(tagId);
      AlertMessages.Show('Disabled', 'Tag Disabled', AlertType.Error);
    } else {
      this._service.insertReportTag(tagId, tagValue).subscribe(

      (data) => {

        this.getTagsData();
        AlertMessages.Show('Enabled', 'Tag Enabled with value:' + tagValue, AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed','Could not Insert!', AlertType.Error);
      });
    }
  }

  //code for getting tags
  getTagsData() {
    this.showOverlayTag = true;
    this.mainViewError.display = false;
    this._service.getAllTagsData().subscribe(
    (data) => {
      this.reportTagsList = data['reportList'];
      this.allReportTagsList = data['allReportList'];
      this.imageTagsList = data['imageTagList'];
      this.descriptionTagsList = data['descTagList'];
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlayTag = false;
    });
  }

  enableReportTag(tagId) {
    this.showOverlayTag = true;
    this._service.enableReportTag(tagId).subscribe(
    (data) => {
      let changedIndex = this.reportTagsList.findIndex(report => report.id == tagId);
      this.reportTagsList[changedIndex]['isUsed'] = true;
      AlertMessages.Show('Success', 'Tag Enabled', AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not Enable!', AlertType.Error);
    }).add(() => {
      this.showOverlayTag = false;
    });

  }

  stateChange(id, stateValue) {
    if (stateValue == null || stateValue == '' || stateValue == undefined) {
      AlertMessages.Show('Warning', 'Enter a value', AlertType.Warning);
      this.getStates();
    } else {
      let indexState = this.stateList.findIndex(i => i.id == id);
      let icdVal = this.stateList[indexState].name;
      if (icdVal.toLowerCase().trim() == stateValue.toLowerCase().trim()) {
        this.stateList[indexState].isEnabled = false;
      } else {
        let stateIndexIs = this.stateList.filter(state => state.name.toLowerCase().trim() == stateValue.toLowerCase().trim())[0];
        if (stateIndexIs !== undefined) {
          let indexVal = this.stateList.findIndex(state => state.id == id);
          this.stateList[indexVal].isEnabled = false;
          AlertMessages.Show('Warning', 'State Name Already Exist', AlertType.Warning);
        } else {
          this.showAddLoader = true;
          this._service.changeState(id, stateValue).subscribe(
          (data) => {
            let stateIndex = this.stateList.findIndex(state => state.id == id);
            this.stateList[stateIndex].Name = stateValue;
            this.stateList[stateIndex].IsEnabled = false;
            AlertMessages.Show('Updated', 'State Updated Successfully', AlertType.Success);
          },
          (error) => {
            AlertMessages.Show('Failed', 'Could not update!', AlertType.Error);
          }).add(() => {
            this.showAddLoader = false;
          });
        }
      }
      // ends
    }
  }

  setTagStatus(index, column, image, description, country) {
    this.activeElement = index;
    this.columnTagStatus = column;
    this.imageTagStatus = image;
    this.descriptionTagStatus = description;
    this.countryTagStatus = country;
  }

  changeEditState(codeId) {
    let stateListData = this.stateList.findIndex(state => state.id == codeId);
    this.stateList[stateListData].IsEnabled = true;
  }

  onStateAdd(form) {
    this.showAddLoader = true;
    this._service.insertState(form.value.TagLabelState).subscribe(
    (data) => {
      if (data['ReturnedId'] != '0' && data['ReturnedId'] != '-1') {
        let InsertedValue = {
          Id: data['ReturnedId'],
          Name: form.value.TagLabelState,
          IsEnabled: false
        };
        this.stateList.splice(0, 0, InsertedValue);
      }
      form.reset();
      AlertMessages.Show('Success', data['StatusMessage'] as string, AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failure', 'Could not Add State!', AlertType.Error);
    }).add(() => {
      this.showAddLoader = false;
    });
  }

  onAddition(form, type) {
    if (type == 1){
      this._service.insertTag(form.value.TagLabelImg, form.value.TagValueImg, type).subscribe(
      (data) => {

        this.insertTagValue(form.value.TagLabelImg, form.value.TagValueImg, data, form, type);
      },
      (error) => {
        AlertMessages.Show('Failed','Could not Add!', AlertType.Error);

      });
    } else {
      this._service.insertTag(form.value.TagLabel, form.value.TagValue, type).subscribe(
      (data) => {

        this.insertTagValue(form.value.TagLabel, form.value.TagValue, data, form, type);
      },
      (error) => {
        AlertMessages.Show('Failed','Could not Add!', AlertType.Error);
      });
    }
  }

  insertTagValue(formValue1, formValue2, data, form, type) {
    if (data['ReturnedId'] != '0') {
      let InsertedValue = {
        id: data['ReturnedId'],
        tagName: formValue1,
        isUsed: true,
        columnDisplay: formValue2
      };
      if (type == 1){
        this.imageTagsList.splice(0, 0, InsertedValue);
        this.getTagsData();
      } else {
        this.descriptionTagsList.splice(0, 0, InsertedValue);
      }

      form.reset();
      AlertMessages.Show('Success', data['StatusMessage'] as string, AlertType.Success);
    } else {
      AlertMessages.Show('Warning', data['StatusMessage'] as string, AlertType.Warning);

    }

  }


  clearData(form) {
    form.reset();
  }

  deleteTag(tagId, type) {
    if (tagId != '' || tagId != undefined || tagId != null) {
      let response = confirm('Are you sure You want to delete ?' );
      if (response) {
        this._service.deleteTag(tagId, type).subscribe(
        (data) => {

            if (type == 1 || type == 2) AlertMessages.Show('Deleted', 'Tag Deleted', AlertType.Success);
            let deletedIndex: number;
            switch (type) {

              case TagInfoEnum.Image:
                  deletedIndex = this.imageTagsList.findIndex(i => i.id == tagId);
                  this.imageTagsList.splice(deletedIndex, 1);
                  break;
              case TagInfoEnum.Description:
                  deletedIndex = this.descriptionTagsList.findIndex(i => i.id == tagId);
                  this.descriptionTagsList.splice(deletedIndex, 1);
                  break;
              default:
                alert('ERROR: ' + type + ' is not accounted for..');
            }
        },
        (error) => {
        AlertMessages.Show('Failed','Could not Delete!', AlertType.Error);
        });
      }
    }
  }

  changeTag (tagId, tagValue, type) {
    if (tagValue == null || tagValue == '' || tagValue == undefined) {
      AlertMessages.Show('Warning', 'Enter a value', AlertType.Warning);
      this.getTagsData();
    } else {
      let index: number;
      switch (type) {
        case TagInfoEnum.Report:
          index = this.reportTagsList.filter(tag => tag.tagName.toLowerCase().trim() == tagValue.toLowerCase().trim())[0];
          if (index !== undefined) {
            this.showAlertForChangeTag(tagId, tagValue, type, 'warning');
          } else {
           this.showAlertForChangeTag(tagId, tagValue, type, 'success');
          }
          break;
        case TagInfoEnum.Image:
          index = this.imageTagsList.filter(tag => tag.columnDisplay.toLowerCase().trim() == tagValue.toLowerCase().trim())[0];
          if (index !== undefined) {
            this.showAlertForChangeTag(tagId, tagValue, type, 'warning');
          } else {
            this.showAlertForChangeTag(tagId, tagValue, type, 'success');
          }
          break;
        case TagInfoEnum.Description:
          index = this.descriptionTagsList.filter(tag => tag.columnDisplay.toLowerCase().trim() == tagValue.toLowerCase().trim())[0];
          if (index !== undefined) {
            this.showAlertForChangeTag(tagId, tagValue, type, 'warning');
          } else {
            this.showAlertForChangeTag(tagId, tagValue, type, 'success');
          }
          break;
        default:
          alert('ERROR: ' + type + ' is not accounted for..');
      }
    }
  }

  showAlertForChangeTag(tagId, tagValue, type, text) {
    if (text === 'success') {
      this._service.changeTag(tagId, tagValue, type).subscribe(
      (data) => {

      AlertMessages.Show('Success', 'Tag Updated', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not Update!', AlertType.Error);
      }).add(() => {
        this.getTagsData();
      })
    } else {
      AlertMessages.Show('Warning', 'Tag Name Already Exist', AlertType.Warning);
    }
  }


  noSpecialChar(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!((charCode >= 65) && (charCode <= 90) || (charCode >= 97) && (charCode <= 122) || (charCode >= 48) && (charCode <= 57))) {
      AlertMessages.Show('Warning', 'Special Characters are not allowed!!!', AlertType.Warning);
      return false;
    }
    return true;
  }
}
